import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

import { LoadingLogo } from '@fmbt/ui/LoadingSpinner';
import {
  INVITE_NULL_PATH,
  consumeInvitePostLogoutReturnPath
} from 'utils/URL/invite-post-logout-return-path';

/** Dev-only: survives StrictMode re-running the state initializer and remounting. */
let devStrictModeInvitePath: string | null | undefined;

function readDevStrictModeInvitePath(): string | null {
  if (devStrictModeInvitePath === undefined) {
    devStrictModeInvitePath = consumeInvitePostLogoutReturnPath();
  }
  return devStrictModeInvitePath;
}

/** @internal Exported for unit tests. */
export function resetDevStrictModeInvitePathForTests(): void {
  devStrictModeInvitePath = undefined;
}

export default function ResumeInvite(): JSX.Element {
  const navigate = useNavigate();

  useEffectOnce(() => {
    const invitePath = import.meta.env.DEV
      ? readDevStrictModeInvitePath()
      : consumeInvitePostLogoutReturnPath();
    navigate(invitePath ?? INVITE_NULL_PATH, { replace: true });
  });

  return <LoadingLogo subtitle="Loading invitation..." />;
}
